<div class="pdf-wrapper">
    <iframe *ngIf="LANGUAGE==LANGUAGE_ENUM.EN" src="/pep/pdf/PEP_Datenuebersicht.pdf" frameborder="0"></iframe>
    <iframe *ngIf="LANGUAGE!=LANGUAGE_ENUM.EN" src="/pep/pdf/PEP_Datenuebersicht.pdf" frameborder="0"></iframe>
</div>
